import dictionary from './Staking.dictionary.json';

export enum StakeType {
  SINGLE = 1,
  EXPRESS = 2,
  SYSTEM = 3,
}

//TODO: Вынести в src/constants/analytics.ts, когда будет поправлен eslint config
export const StakeTypeName = {
  [StakeType.SINGLE]: 'single',
  [StakeType.EXPRESS]: 'express',
  [StakeType.SYSTEM]: 'system',
};

export const STAKE_TYPE_DICTIONARY = {
  [StakeType.SINGLE]:  dictionary.single,
  [StakeType.EXPRESS]: dictionary.express,
  [StakeType.SYSTEM]:  dictionary.system,
};

export enum CashoutMode {
  PROHIBITED = 1,
  BY_REQUEST = 2,
  ALLOWED = 3,
}

export enum StakeCashoutState {
  AWAITING = 0,
  PROCESSING = 1,
  ACCEPTED = 2,
  REJECTED = 3,
  FAILED = 4,
  AWAITING_AMOUNT = 5,
}

// https://confluence.tennisi.it/pages/viewpage.action?pageId=757663860
export enum BetState {
  ACTIVE = 10,
  WIN = 20,
  LOSE = 30,
  RETURN = 40,
  CANCEL = 50,
}

export enum StakeState {
  ACTIVE = 10,
  WIN = 20,
  LOSE = 30,
  RETURN = 40,
  CANCEL = 50,
  CASH_OUT = 60,
  PAID = 70,
  AWAITING = 80,
  UNPLACED = 90,
}

export enum SystemState {
  ACTIVE = '10',
  WIN = '20',
  LOSE = '30',
}

export enum CashoutErrorCode {
  AMOUNT_CHANGED = 1,
  BETTING_IS_CLOSED = 2,
  CASH_OUT_IN_PROCESS = 10,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  NOT_ACCEPTABLE = 406,
  INTERNAL_SERVER_ERROR = 500,
}

// ---

export const STAKE_OUTCOME_STATUS = {
  ACTIVE:   Symbol('stake_outcome:active'),
  WON:      Symbol('stake_outcome:won'),
  LOST:     Symbol('stake_outcome:lost'),
  RETURNED: Symbol('stake_outcome:returned'),
  AWAITING: Symbol('stake_outcome:awaiting'),
  CASHOUT:  Symbol('stake_outcome:cashout'),
};

export const BET_OUTCOME_STATUS = {
  ACTIVE:   Symbol('bet_outcome:active'),
  WON:      Symbol('bet_outcome:won'),
  LOST:     Symbol('bet_outcome:lost'),
  RETURNED: Symbol('bet_outcome:returned'),
  CANCELED: Symbol('bet_outcome:canceled'),
};
